<template>
    <div>
        <!-- 雷达图 -->
        <div :id="id" style="height:400px;width:100%"></div>
    </div>
</template>
<script>
import {statisticsAPI } from 'liankong-ui-api'
import * as echarts from 'echarts'
export default {
    props:{
        id:{
            type:String,
            default:'myCharts'
        },
        title:{
            type:String,
            default:''
        }
    },
    data(){
        return {
            
        }
    },
    mounted(){
    },
    methods:{
        getList(startDay,endDay,queryType){
            statisticsAPI.statisVisits({
                endDay,startDay,queryType
            }).then(res=>{
                if(res.code==0){
                    let mCharts = echarts.init(document.getElementById(this.id))
                    let option = {
                        color: ['#69a3e7', '#06f1ef'],
                        title: [{
                            text: '用户访问量统计',
                            x:"3%",
                            y:'4%',
                            textStyle:{
                                fontSize:15,
                                color:'#06f1ef'
                            }
                        }],
                        tooltip: {
                            trigger: 'axis'
                        },
                        legend: {
                            left: 'center',
                            top: '7%',
                            textStyle: {
                                color: '#ffd285',
                            },
                            data: ['浏览量','访客数']
                        },
                        grid: {
                            left: '4%',
                            right: '4%',
                            top: '17%',
                            bottom: '6%',
                            containLabel: true
                        },
                        toolbox: {
                            "show": false,
                            feature: {
                                saveAsImage: {}
                            }
                        },
                        xAxis: {
                            type: 'category',
                            "axisLine": {
                                lineStyle: {
                                    color: '#fff'
                                }
                            },
                            "axisTick": {
                                "show": false
                            },
                            axisLabel: {
                                textStyle: {
                                    color: '#fff'
                                }
                            },
                            boundaryGap: false,
                            data: res.data.map(item=>{
                                if(queryType==1){
                                    return item.timeNode.slice(-2)+ ('时')
                                } else if(queryType==2){
                                    return item.timeNode.substring(0,4)+ ('年') + item.timeNode.substring(4,6) + ('月') + item.timeNode.substring(6,8)+ ('日')
                                } else {
                                    return item.timeNode.slice(-2)+ ('月')
                                }
                                
                            })
                        },
                        yAxis: [{
                            name:'浏览量(PV)',
                            "axisLine": {
                                lineStyle: {
                                    color: '#fff'
                                }
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: '#fff'
                                }
                            },
                            "axisTick": {
                                "show": false
                            },
                            axisLabel: {
                                textStyle: {
                                    color: '#fff'
                                }
                            },
                            type: 'value'
                        },{
                            name:'访客量(UV)',
                            "axisLine": {
                                lineStyle: {
                                    color: '#fff'
                                }
                            },
                            splitLine: {
                                show: false,
                                lineStyle: {
                                    color: '#fff'
                                }
                            },
                            "axisTick": {
                                "show": false
                            },
                            axisLabel: {
                                textStyle: {
                                    color: '#fff'
                                }
                            },
                            type: 'value'
                        }],
                        series: [{
                            name: '浏览量',
                            smooth: true,
                            type: 'line',
                            symbolSize: 0,
                            symbol: 'circle',
                            areaStyle: { //区域填充样式
                                    normal: {
                                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: "rgba(105,163,231,0.3)"


                                            },
                                            {
                                                offset: 0.8,
                                                color: "rgba(105,163,231,0)"
                                            }
                                        ], false),
                                        shadowColor: 'rgba(0, 0, 0, 0.1)', //阴影颜色
                                        shadowBlur: 50 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                                    }
                                },
                            data: res.data.map(item=>item.pv)
                        }, {
                            name: '访客数',
                            smooth: true,
                            type: 'line',
                            symbolSize: 0,
                            yAxisIndex:1,
                            symbol: 'circle',
                            areaStyle: { //区域填充样式
                                    normal: {
                                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: "rgba(6, 241, 239,0.3)"


                                            },
                                            {
                                                offset: 0.8,
                                                color: "rgba(6, 241, 239,0)"
                                            }
                                        ], false),
                                        shadowColor: 'rgba(0, 0, 0, 0.1)', //阴影颜色
                                        shadowBlur: 50 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                                    }
                                },
                            data: res.data.map(item=>item.uv)
                        }]
                    }
                    mCharts.setOption(option)
                } else {
                    this.$message.error(res.message)
                }
            })
        },
    }
}
</script>
